import {
    Avatar,
    Box,
    Card,
    CardActions,
    CardContent,
    IconButton,
    Rating,
    Typography,
    Tooltip
} from "@mui/material";

import { formatDate, stringAvatar } from "../services/utils";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import { Actions } from "../types/Actions";
import { Draggable } from "react-beautiful-dnd";
import { Contact } from "../types/Contact";
import { ContactUpdatePayload } from "../services/connector";

export default function ContactCard({
    contact,
    index,
    onCardAction,
    onContactUpdate
}: {
    contact: Contact;
    index: number;
    onCardAction: (contact: Contact, action: Actions) => void;
    onContactUpdate: (contact: Contact, payload: ContactUpdatePayload) => void;
}) {
    const fullName = contact.firstname + " " + contact.lastname;

    const handleContactRatingUpdate = async (e: any, rating: number | null) => {
        await onContactUpdate(contact, { rating });
    }

    return (
        <Draggable draggableId={contact.id} index={index}>
            {(provided, snapshot) => {
                return (
                    <Card
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        sx={{
                            opacity: snapshot.isDragging ? 0.5 : 1,
                            userSelect: "none",
                            ...provided.draggableProps.style,
                        }}
                    >
                        <CardContent sx={{ display: "flex", alignItems: "center" }}>
                            <Avatar
                                {...stringAvatar(fullName)}
                                src={contact.profile ? `/profiles/${contact.profile}` : ""}
                            />
                            <Box>
                                <Typography variant="h6">{fullName}</Typography>
                                <Rating value={contact.evaluation.rating} onChange={handleContactRatingUpdate} />
                                <Typography variant="body2" color="textSecondary">
                                    {formatDate(contact.candidatureDate)}
                                </Typography>
                            </Box>
                        </CardContent>
                        <CardActions sx={{ justifyContent: "space-evenly" }}>
                            <Tooltip title="Curriculum Vitae">
                                <IconButton
                                    onClick={() => onCardAction(contact, Actions.DISPLAY_CV)}
                                >
                                    <ContactPageOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Lettre de motivation">
                                <IconButton
                                    onClick={() => onCardAction(contact, Actions.DISPLAY_MOTIVATION_LETTER)}
                                >
                                    <ArticleOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Contact / Messages">
                                <IconButton
                                    onClick={() => onCardAction(contact, Actions.DISPLAY_CONTACT)}
                                >
                                    <AlternateEmailOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Commentaires / Notes personnelles">
                                <IconButton
                                    onClick={() => onCardAction(contact, Actions.DISPLAY_NOTES)}
                                >
                                    <CommentOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        </CardActions>
                    </Card>
                );
            }}
        </Draggable>
    );
}
